import React, { ReactNode, useRef } from 'react';

import { useFilterSize } from 'components/TopicFilters/utils/useFilterSize';

import Menu from 'components/base/Menu/Menu';
import Span from 'components/elements/span';
import { ListItem } from 'components/base/TopicFiltersDropdown/GenreDropdown/GenreDropdown';
import AnimatedCaret from 'components/base/AnimatedCaret';

import { ButtonBox } from './styles';
import colors from 'styles/themes/colors';

import { ILabelValuePair } from 'types/shared';

const DropdownButton: React.FC<{
  defaultLabel: string;
  isOpen: boolean;
  isSubscriptionForm: boolean;
  selectedItems: any[];
}> = ({ defaultLabel, isOpen, isSubscriptionForm, selectedItems }) => {
  const text =
    selectedItems && selectedItems.length > 0
      ? selectedItems
          .filter((channel: any) => channel.value !== 'all')
          .map((item: ILabelValuePair<string>) => item.label)
          .join(', ')
      : defaultLabel;
  const textTrimmed = text.replace(/(,?\s?)$/, '');

  const ref = useRef(null);
  useFilterSize(ref);

  return (
    <ButtonBox
      isOpen={isOpen}
      bg="white"
      py={1}
      px={2}
      display="flex"
      alignItems="flex-start"
      justifyContent="flex-start"
      alignContent="stretch"
      color={colors.NightBlue}
      isSubscriptionForm={isSubscriptionForm}
    >
      <Span alignSelf="auto" marginRight="8px" fontWeight={600} ref={ref}>
        {textTrimmed}
      </Span>
      <Span marginLeft="auto" alignSelf="auto" color={colors.NightBlue}>
        <AnimatedCaret isPointingUp={isOpen} />
      </Span>
    </ButtonBox>
  );
};

const getButtonWithDefaultLabel = (defaultLabel?: string): ReactNode => {
  const LabeledButton: React.FC<any> = (props: any) => (
    <DropdownButton {...props} defaultLabel={defaultLabel} />
  );
  return LabeledButton;
};

interface IChannelDropdownProps {
  defaultLabel: string;
  items: any[];
  itemToString: (item: any) => string;
  onChange: (param?: any) => void;
  selectedItems: any[];
}

const ChannelDropdown: React.FC<IChannelDropdownProps> = (props) => {
  const { defaultLabel, items, itemToString, onChange, selectedItems } = props;

  return (
    <Menu
      items={items}
      onChange={onChange}
      itemToString={itemToString}
      Button={getButtonWithDefaultLabel(defaultLabel)}
      Item={ListItem}
      isMultipleSelection
      selectedItems={selectedItems}
      selectedItem={null}
      isSubscriptionForm
      isFirstUnderlined
    />
  );
};

export default ChannelDropdown;
